
//export const SERVER_URL = "http://localhost:8080/backend";
export const SERVER_URL = "https://api.fos-matnuhpv.ma/backend";
